import { __APP_NAME__ } from "config/static";

export default function Footer() {
  return (
    <div className="mt-3 flex w-full justify-center self-end">
      <footer className="portal-topbar flex min-h-16 w-full items-center rounded-[1.75rem] px-5 py-3">
        <div className="m-auto flex w-full flex-col items-center justify-between gap-2 md:flex-row">
          <span
            className="text-sm font-bold sm:text-center portal-accent"
            style={{ color: "var(--layout-text-muted)" }}
          >
            {__APP_NAME__}
          </span>

          <span
            className="text-xs font-semibold"
            style={{ color: "var(--layout-text-muted)" }}
          >
            متجر رقمي لشحن الألعاب والتطبيقات والبطاقات.
          </span>

          <span
            className="text-sm font-bold sm:text-center portal-accent"
            style={{ color: "var(--layout-text-muted)" }}
          >
            تصميم و تطوير{" "}
            <a
              className="hover:underline text-orange-500"
              href="https://wa.me/963930071762"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              Dr TECH{" "}
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}
